import { dataProfileManage } from '../../snapshot/profile'
import type { PostString, PostInt, PostCfgRename, PostImportSetting, PostCfgBindShortCut } from '../../define/request'
import { deviceManager } from '../../device/device_manager'
import { delay } from '@libs/utils/tools'
import { HuoChaiRenDevices, RoYuanDevice, VirtualRA68 } from '@hid/define/define'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { Fe87v2DeviceList, He6UltraDeviceList, JingTaiV2DeviceList, SlefDevMagnetList } from '@/define/device_vendor'
import { createDecorates } from '@hid/define/define_profile'
import { ra68SideLight } from '@hid/define/define_side_light'

export const handleCfgList = async () => {
  return dataProfileManage().CfgList()
}
export const handleCfgSwitch = async (data: PostInt) => {
  const list = dataProfileManage().CfgSwitch(data)

  if (RoYuanDevice.includes(deviceManager.deviceID)) {
    await deviceManager.deviceDriver.reset()
    await delay(500)
  } else if (He6UltraDeviceList.includes(deviceManager.deviceID) || Fe87v2DeviceList.includes(deviceManager.deviceID) || SlefDevMagnetList.includes(deviceManager.deviceID) || HuoChaiRenDevices.includes(deviceManager.deviceID)) {
    await deviceManager.deviceDriver.reset()
  }
  deviceManager.deviceDriver.setChangeProfileFlag(true)

  // 导入没有装饰灯配置时, 切换配置文件会导致装饰灯无法设置
  if (!deviceManager.deviceDriver.save.Decorates) {
    if (deviceManager.deviceID == VirtualRA68) {
      deviceManager.deviceDriver.save.Decorates = createDecorates(0, 75, 75, 0, ra68SideLight)
    }
    if (HuoChaiRenDevices.includes(deviceManager.deviceID)) {
      deviceManager.deviceDriver.save.Decorates = createDecorates(1, 80, 80, 0, ra68SideLight)
    }
  }

  await deviceManager.deviceDriver.syncConfig()

  await deviceManager.deviceDriver.syncLeds()
  await deviceManager.deviceDriver.syncDecorationLed()
  await deviceManager.deviceDriver.syncDynamicColor()

  if (dataProfileManage().dataProfile.LightLastIsCustom || JingTaiV2DeviceList.includes(deviceManager.deviceID)) {
    if (!specialCheckCurrent(speciaBehiver.DeviceOfRoyuan) && !specialCheckCurrent(speciaBehiver.DevicesOfJingtai_V2)) {
      await delay(500) //不加延迟, 会导致ESC键自定义灯效失败
    }
    await deviceManager.deviceDriver.syncCustomColor()
  }

  await deviceManager.deviceDriver.syncKeys()
  await deviceManager.deviceDriver.syncMacros()
  await deviceManager.deviceDriver.magnet?.syncSeniorkey()

  await deviceManager.deviceDriver.magnet?.syncKeysTravels()
  await deviceManager.deviceDriver.magnet?.syncKeysDeadZone()

  deviceManager.deviceDriver.setChangeProfileFlag(false)
  return list
}
export const handleCfgCreate = async (data: PostString) => {
  return dataProfileManage().CfgCreate(data)
}
export const handleCfgDelete = async (data: PostInt) => {
  return dataProfileManage().CfgDelete(data)
}
export const handleCfgRename = async (data: PostCfgRename) => {
  return dataProfileManage().CfgRename(data)
}
export const handleCfgImport = async (data: PostImportSetting) => {
  return dataProfileManage().CfgImport(data)
}
export const handleCfgExport = async (data: PostInt) => {
  return dataProfileManage().CfgExport(data)
}

// 只是绑定快捷键的数据，用于回显，具体绑定快捷键的操作在exe服务中进行，因为快捷键是系统级功能且与本地配置文件绑定
export const handleCfgBindShortcut = async (data: PostCfgBindShortCut) => {
  return dataProfileManage().CfgBindShortcut(data)
}
